import type { JSX } from 'solid-js';
import { For, Show } from 'solid-js';
import { t } from '../i18n';
import { POLICY_ROOT_KEY, type PolicySection } from '../lib/policy-view';
import { Panel } from './Panel';

// Every section of the resolved policy, one code panel each (arc 101 slice 06).
// Titles are the `.maintainer.yml` KEYS, not translated labels: the tab answers
// "what did my file resolve to", so a key a maintainer can't grep for in their
// own file would be a worse label, however prettier. Section building lives in
// `lib/policy-view.ts` — this file only lays them out.

export function PolicySections(props: { sections: readonly PolicySection[] }): JSX.Element {
  return (
    <Show
      when={props.sections.length > 0}
      fallback={<div class="list-empty">{t('repo_detail.policy_empty')}</div>}
    >
      <div class="repo-policy__grid">
        <For each={props.sections}>
          {(section) => (
            <Panel
              class="repo-policy__section"
              title={section.key === POLICY_ROOT_KEY ? t('repo_detail.policy_root') : section.key}
            >
              <pre class="code-block">{section.text}</pre>
            </Panel>
          )}
        </For>
      </div>
    </Show>
  );
}
